import React from 'react';
import aboutMain from '../assets/images/aboutmain.jpg';
import aboutSmall from '../assets/images/aboutsmall.jpg';
import starIcon from '../assets/images/star.svg';
import { FiBox, FiCheck, FiStar, FiUsers } from 'react-icons/fi';
import { LuRocket } from 'react-icons/lu';

const TICKER_ITEMS = [
  'INNOVATIVE APPS',
  'FLUTTER EXPERTS',
  'iOS & ANDROID',
  'CROSS-PLATFORM',
  'APP STORE READY',
  'POWERFUL DESIGN',
  'DI LABS',
  'QUALITY FIRST',
];

const IMPACT_STATS = [
  { value: '22+', label: 'Apps Delivered', icon: FiBox },
  { value: '1M+', label: 'User Reach', icon: FiUsers },
  { value: '4.8', label: 'Avg. Rating', icon: FiStar },
  { value: '100%', label: 'Quality Focused', icon: FiCheck },
];

const About = () => {
  // Duplicate for seamless infinite scroll
  const tickerList = [...TICKER_ITEMS, ...TICKER_ITEMS];

  return (
    <>
      <section className="about-section" id="about">
        <div className="about-container">

          {/* Top Left: Badge + Heading + Description */}
          <div className="about-top-left">
            <div className="about-badge">
              About DI Labs
            </div>

            <h2 className="about-title">
              Building Innovative Digital Solutions For Everyone
            </h2>

            <p className="about-description">
              DI Labs is a mobile app development studio specializing in Flutter-based applications for iOS and Android. We create high-quality apps across categories like Al tools, productivity, sports tracking, and entertainment - available on major app stores.
            </p>
          </div>

          {/* Top Right: Main Image */}
          <div className="about-right">
            <div className="about-card about-card-img-main">
              <img src={aboutMain} alt="DI Labs developer" className="about-card-img" />
            </div>
          </div>

          {/* Bottom Row: small image + text card + stats — one line */}
          <div className="about-bottom-row">
            <div className="about-card about-card-img-small">
              <img src={aboutSmall} alt="DI Labs team working" className="about-card-img" />
            </div>

            <div className="about-card about-card-text">
              <div className="about-card-text-icon" aria-hidden="true">
                <LuRocket />
              </div>
              <div>
                <h3>Delivering Impactful Apps</h3>
                <p className="about-card-text-content">
                  From concept to launch, we handle design, development, testing,
                  and deployment — ensuring smooth performance and an exceptional
                  user experience.
                </p>
              </div>
            </div>

            <div className="about-impact" aria-label="Our impact at a glance">
              <div className="about-impact-heading">
                <span aria-hidden="true" />
                <h3>Our Impact At A Glance</h3>
                <span aria-hidden="true" />
              </div>

              <div className="about-impact-grid">
                {IMPACT_STATS.map(({ value, label, icon: Icon }) => (
                  <div className="about-impact-stat" key={label}>
                    <div className="about-impact-icon" aria-hidden="true">
                      <Icon />
                    </div>
                    <strong>{value}</strong>
                    <small>{label}</small>
                    <i aria-hidden="true" />
                  </div>
                ))}
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* Scrolling Ticker Band */}
      <div className="about-ticker-band" aria-hidden="true">
        <div className="about-ticker-track">
          {tickerList.map((item, i) => (
            <span className="about-ticker-item" key={i}>
              {item}
              <img src={starIcon} alt="" className="about-ticker-star" />
            </span>
          ))}
        </div>
      </div>
    </>
  );
};

export default About;
